import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getDashboard } from "../../../Store/dashboard/actions";
import { StatusTab, statusTabCounts } from "./productListFilters";

const TABS: Array<{ key: Exclude<StatusTab, "needsPhoto">; label: string; laptopOnly?: boolean }> = [
  { key: "all", label: "All" },
  { key: "drafted", label: "Drafts" },
  { key: "published", label: "Live" },
  { key: "inStock", label: "In stock", laptopOnly: true },
  { key: "outOfStock", label: "Out of stock" },
];

/**
 * All · Drafts · Live · (In stock) · Out of stock, with counts from /dashboard/dashboardwidgets for the
 * current "Added" window. Replaces the KPI strip; picking a tab keeps every other filter.
 */
const ProductStatusTabs = (props: any) => {
  const { createdAfter = "", createdBefore = "", showInStock, active, onSelect, stockAdjust, refreshKey, needsPhotoCount } = props;
  // Needs photo shows only while something needs a photo (or while it is the open tab), never as an empty tab.
  const showNeedsPhoto = typeof needsPhotoCount === "number" && (needsPhotoCount > 0 || active === "needsPhoto");
  useEffect(() => {
    props.getDashboard(() => undefined, {
      createdAfter: createdAfter || undefined,
      createdBefore: createdBefore || undefined,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createdAfter, createdBefore, refreshKey]);
  const counts = statusTabCounts(props.dashboardDetails?.data, stockAdjust);
  return (
    <div className="pl-tabs" role="tablist" aria-label="Product status">
      {TABS.filter((tab) => showInStock || !tab.laptopOnly).map((tab) => (
        <button
          key={tab.key}
          type="button"
          role="tab"
          aria-selected={active === tab.key}
          className={`pl-tab${active === tab.key ? " is-on" : ""}`}
          onClick={() => onSelect(tab.key)}
        >
          {tab.label}
          {counts ? <b>{counts[tab.key]}</b> : null}
        </button>
      ))}
      {showNeedsPhoto ? (
        <button
          type="button"
          role="tab"
          aria-selected={active === "needsPhoto"}
          className={`pl-tab${active === "needsPhoto" ? " is-on" : ""}`}
          onClick={() => onSelect("needsPhoto")}
        >
          Needs photo
          <b>{needsPhotoCount}</b>
        </button>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  dashboardDetails: state?.dashboardReducer?.getDashboardDetails,
});

export default connect(mapStateToProps, { getDashboard })(ProductStatusTabs);
